import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p492925080642334720',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
